import type { Folder } from '@efdigital/ll-addon-data';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export default class LibraryFoldersNewRoute extends Route {
  @service declare store: Store;

  model(params: { parent: string }) {
    const folder = this.store.createRecord('folders', {
      parent: params.parent,
      name: '',
    }) as Folder;

    return { folder, parent: params.parent };
  }
}
